<template>
  <v-col cols="12" sm="12">
    <v-col cols="6" sm="6">
      <v-toolbar-title>Usuarios</v-toolbar-title>
      <br />
      <v-text-field
        v-model="buscar"
        :append-icon="'mdi-select-search'"
        label="Buscar usuario por Id / usuario / Descripciòn"
        dense
      ></v-text-field>
    </v-col>
    <v-data-table
      :headers="headers"
      :items="usuarios"
      item-key="idusuario"
      sort-by="idusuario"
      :search="buscar"
      :header-props="headerProps"
      :footer-props="footerProps"
      no-data-text="No se encontraron registros"
      no-results-text="No se encontraron registros en la búsqueda"
    >
      <!-- <template v-slot:[`item.Estado`]="{ item }">
        <v-chip :color="getColor(item.Estado)">
          {{ item.Estado == 1 ? "Activo" : "Inactivo" }}
        </v-chip>
      </template> -->

      <template v-slot:[`item.tipoUsuario`]="{ item }">
        {{ getTextoTipoUsuario(item.tipoUsuario) }}
      </template>

      <template v-slot:[`item.estado`]="{ item }">
        <v-chip :color="getColor(item.estado)">
          {{ getTextoEstado(item.estado) }}
        </v-chip>
      </template>

      <template v-slot:top>
        <v-toolbar flat>
          <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
          <v-spacer></v-spacer>
          <v-tooltip left color="indigo">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                elevation="10"
                small
                fab
                color="indigo"
                dark
                class="mx-2"
                @click="AbrirModal(0)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Agregar Usuario</span>
          </v-tooltip>

          <v-dialog v-model="dialogDelete" max-width="800px">
            <v-card>
              <v-card-title class="text-h5"
                >¿Está seguro que desea eliminar esta usuario?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip left color="green">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              elevation="10"
              small
              fab
              color="green"
              dark
              class="mx-2"
              @click="AbrirModalModificacion(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> mdi-pencil </v-icon>
            </v-btn>
          </template>
          <span>Modificar usuario</span>
        </v-tooltip>
        <v-tooltip left color="red">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              elevation="10"
              small
              fab
              color="red"
              dark
              class="mx-2"
              @click="cerrarusuario(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> mdi-delete </v-icon>
            </v-btn>
          </template>
          <span>Cerrar usuario</span>
        </v-tooltip>
        <v-tooltip left color="blue">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              elevation="10"
              small
              fab
              color="blue"
              dark
              class="mx-2"
              @click="verDetalleusuario(item)"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> mdi-eye </v-icon>
            </v-btn>
          </template>
          <span>Ver Detalle</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <insertusuario
      ref="insertusuario"
      @recargarListado="recargarListado"
    ></insertusuario>
    <dialog-mensaje ref="dialogMensaje" @resultado="confirmarOperacion" />
    <!-- <dialog-mensaje
      ref="dialogMensaje"
      @resultado="confirmarCierreusuario"
    /> -->
  </v-col>
</template>
<script>
//import dialogMensaje from "@/components/modalMensaje.vue";
import insertusuario from "@/modulos/Usuarios/componentes/modalUsuarios.vue";
import dialogMensaje from "@/components/modalMensaje.vue";
//import insertusuario from "@/modulos/Materiales/componentes/modalMateriales.vue";
import axios from "axios";
export default {
  components: {
    insertusuario,
    dialogMensaje,
  },
  data: () => ({
    idusuarioEliminar: "",
    tipoConsulta: "",
    idCuadrillaEliminar: "",
    dialogDelete: false,
    usuarios: [],
    headers: [
      {
        text: "Nombre Usuario",
        align: "start",
        sortable: true,
        value: "nombreUsuario",
        class: "black white--text",
      },
      {
        text: "Tipo de Usuario",
        value: "tipoUsuario",
        class: "black white--text",
      },
      { text: "Empresa", value: "empresa", class: "black white--text" },
      { text: "Estado", value: "estado", class: "black white--text" },
      {
        text: "Acciones",
        value: "actions",
        sortable: false,
        class: "black white--text",
      },
    ],
    headerProps: {
      sortByText: "Ordenar por",
    },
    other: [1, 20, 344, 44444],
    footerProps: {
      itemsPerPageText: "Registros por página",
      pageText: "{0}-{1} de {2}",
      itemsPerPageOptions: [5, 10, 20, 50, 100, { text: "Todos", value: -1 }],
    },
    buscar: "",
    cuadrillas: [],
    editedIndex: -1,
    editedItem: {
      idCuadrilla: "",
      descripcion: 0,
    },
    defaultItem: {
      idCuadrilla: "",
      descripcion: 0,
    },
  }),

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  mounted() {
    // Mostrar los datos en la consola
    //this.getListarCuadrillaByusuario();
    //this.getListarOTusuarios();
    this.getListarUsuarios();
    //this.getListarusuariosByContratista();
  },
  methods: {
    getTextoTipoUsuario(dato) {
      if (dato == 1) {
        return "Administrador";
      }
      if (dato == 2) {
        return "Operador";
      }
      if (dato == 3) {
        return "Contratista";
      }
    },

    recargarListado() {
      this.getListarUsuarios();
    },

    cerrarusuario(item) {
      console.log("Los datos para cerrar el usuario es: ");
      console.log(item.idusuario);
      this.tipoConsulta = 3;
      this.idusuarioEliminar = item.idusuario;
      this.$refs.dialogMensaje.abrirMensajeDialog(
        "Esta por eliminar el usuario N° " +
          item.idusuario +
          ", desea continuar?",
        2,
        "red",
        "Confirmacion",
      );
    },

    async confirmarOperacion(resultadoFinal) {
      console.log("Esto hay en el resultado final");
      console.log(resultadoFinal);
      console.log("El tipo de consulta es: ");
      console.log(this.tipoConsulta);

      var obj;

      if (resultadoFinal == true) {
        if (this.tipoConsulta == 3) {
          // this.url =
          //   this.$store.state.urlBase + "usuario/cerrarusuario?idusuario=";
          // this.idusuarioEliminar;
          this.url =
            this.$store.state.urlBase +
            "usuario/cerrarusuario?idusuario=" +
            this.idusuarioEliminar;

          obj = {
            idusuario: this.idusuario,
          };
        }

        // const config = {
        //   headers: {
        //     Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        //   },
        // };

        var respuesta = await axios
          .post(this.url, obj)
          .then((response) => {
            return response;
          })
          .catch(function () {
            return null;
          });

        console.log("Esto hay en el respuesta");
        console.log(respuesta);

        if (respuesta.status == 200) {
          this.mensajeDelDialog = respuesta.data;

          var mensajeDialog = "";
          if (this.mensajeDelDialog == true) {
            mensajeDialog = "Operacion Exitosa";
          } else {
            mensajeDialog = "Operacion Rechazada";
          }

          this.$refs.dialogMensaje.abrirMensajeDialog(
            mensajeDialog,
            1,
            this.mensajeDelDialog == true ? "green" : "red",
            "Informacion",
          );
        } else {
          console.log("Ingreso en el else de la respuesta");
          this.$refs.dialogMensaje.abrirMensajeDialog(respuesta.Error, 1);
          this.mensajeDelDialog = respuesta.Error;
          this.mensajeDelDialog = respuesta.Error.split("-");
          this.colorDialog = "red";
          this.dialog = true;
        }

        // if (this.bandera == 1) {
        //   console.log("Ingresoe en la bandera 1 para ocultar el dialog");
        //   this.dialogForm = false;
        // }

        this.recargarListado();
      }
    },

    getColor(estado) {
      console.log("Ingreso en la funcion getCOlor");
      if (estado == 1) return "green";
      else if (estado == 0) return "red";
    },

    getTextoEstado(estado) {
      return estado === 1 ? "Activo" : "Inactivo";
    },

    async getListarUsuarios() {
      this.url = this.$store.getters.urlBase + "Usuarios/recuperarUsuarios";

      var listausuario = [];
      this.usuarios = listausuario;

      await axios
        .get(this.url)
        .then((response) => {
          console.log("Respuesta de recuperarOTsusuario");
          console.log(response.data);
          this.usuarios = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      this.loadingButton = false;
    },

    async confirmarCierreCuadrilla(resultadoFinal) {
      //console.log("Ingreso en confirmar cierre ");
      if (resultadoFinal == true) {
        //console.log("Ingreso en el true del confirmar cierre");
        this.url = this.$store.getters.urlBase + "Cuadrilla/cerrarCuadrilla";

        // const config = {
        //   headers: {
        //     Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        //   },
        // };

        var obj = {
          idCuadrilla: this.idCuadrillaEliminar,
          idUsuario: this.$store.getters.usuario.user_id,
        };

        console.log("La direccion es: ");
        console.log(this.url);

        var respuesta = await axios
          .post(this.url, obj)
          .then((response) => {
            return response;
          })
          .catch(function () {
            return null;
          });

        console.log("Esto hay en el respuesta");
        console.log(respuesta);

        if (respuesta.status == 200) {
          this.mensajeDelDialog = respuesta.data;

          var mensajeDialog = "";
          if (this.mensajeDelDialog == true) {
            mensajeDialog = "Operacion Exitosa";
          } else {
            mensajeDialog = "Operacion Rechazada";
          }

          this.$refs.dialogMensaje.abrirMensajeDialog(
            mensajeDialog,
            1,
            this.mensajeDelDialog == true ? "green" : "red",
            "Informacion",
          );
        } else {
          console.log("Ingreso en el else de la respuesta");
          this.$refs.dialogMensaje.abrirMensajeDialog(respuesta.Error, 1);
          this.mensajeDelDialog = respuesta.Error;
          this.mensajeDelDialog = respuesta.Error.split("-");
          this.colorDialog = "red";
          this.dialog = true;
        }

        if (this.bandera == 1) {
          console.log("Ingresoe en la bandera 1 para ocultar el dialog");
          this.dialogForm = false;
        }

        this.$router.push("/Cuadrillas");
      }
    },

    verDetalleusuario(datos) {
      console.log("Ingreso en ver detalle");
      console.log(datos);
      this.$refs.insertusuario.abrirmodalUsuarios(datos);
      //this.$refs.insertusuario.openModal(datos);
    },

    abrirAsignarTareas(datos) {
      this.$router.push({
        name: "Asignar Tarea a Cuadrilla",
        params: { datos },
      });
    },
    AbrirModal() {
      console.log("Presiono abrir el modal");
      // console.log(tipo);
      // this.$refs.abrirmodalUsuario.openModal();
      this.$refs.insertusuario.AbrirModal();
    },
    AbrirModalModificacion(datos) {
      this.$refs.insertusuario.abrirModalModificarusuario(datos);
      //this.$refs.abrirmodalUsuario.(item);
    },
    deleteItem(item) {
      this.editedIndex = this.cuadrillas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.cuadrillas.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    cerrarCuadrilla(datosCuadrilla) {
      this.idCuadrillaEliminar = datosCuadrilla.idCuadrilla;
      this.$refs.dialogMensaje.abrirMensajeDialog(
        "Desea cerrar la cuadrilla " + datosCuadrilla.idCuadrilla + " ?",
        2,
        "red",
        "Aviso",
      );
    },

    async getListarCuadrilla() {
      this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de cuadrilla es:");
        console.log(respuesta.data);
        this.cuadrillas = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    async getListarusuariosByContratista() {
      //console.log("El usuario es");
      console.log(this.$store.getters.usuario.idContratista);

      this.url =
        this.$store.getters.urlBase +
        "usuario/recuperarusuariosContratista?idContratista=" +
        this.$store.getters.usuario.idContratista;
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        // params: {
        //   idusuario:
        //     this.$store.getters.usuario.idRol != 3
        //       ? this.usuarioseleccion
        //       : this.$store.getters.idusuario,
        // },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de usuarios es:");
        console.log(respuesta.data);
        this.usuarios = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    async getRecuperarServicios() {
      this.url = this.$store.getters.urlBase + "Gang/servicios";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("Los servicios son");
        console.log(respuesta.data);
        //this.cuadrillas = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },
  },
};
</script>
